import { useMediaQuery } from '@mui/material'
import { useMemo } from 'react'
import { BREAKPOINTS } from 'theme'

import { useLimitData } from './hooks'
import Table from './LimitTable'
import TableM from './LimitTable-m'

export function LimitList({ token01 }: { token01: boolean }) {
  const isSmallScreen = useMediaQuery(`(max-width: ${BREAKPOINTS.lg}px)`)
  // const chainName = validateUrlChainParam(useParams<{ chainName?: string }>().chainName)
  const data = useLimitData()
  const resData = useMemo(() => {
    if (!data) return null
    if (token01) {
      return (
        data?.sort((a, b) => {
          let priceDifferenceA, priceDifferenceB
          if (a.triggerAboveThreshold) {
            priceDifferenceA = Number(a.twapPrice) - Number(a.triggerPrice)
          } else {
            priceDifferenceA = Number(a.triggerPrice) - Number(a.twapPrice)
          }
          if (b.triggerAboveThreshold) {
            priceDifferenceB = Number(b.twapPrice) - Number(b.triggerPrice)
          } else {
            priceDifferenceB = Number(b.triggerPrice) - Number(b.twapPrice)
          }
          return priceDifferenceB - priceDifferenceA
        }) || null
      )
    } else {
      return (
        data?.sort((a, b) => {
          let priceDifferenceA, priceDifferenceB
          if (a.triggerAboveThreshold) {
            priceDifferenceA = 1 / Number(a.twapPrice) - 1 / Number(a.triggerPrice)
          } else {
            priceDifferenceA = 1 / Number(a.triggerPrice) - 1 / Number(a.twapPrice)
          }
          if (b.triggerAboveThreshold) {
            priceDifferenceB = 1 / Number(b.twapPrice) - 1 / Number(b.triggerPrice)
          } else {
            priceDifferenceB = 1 / Number(b.triggerPrice) - 1 / Number(b.twapPrice)
          }
          return priceDifferenceA - priceDifferenceB
        }) || null
      )
    }
  }, [data, token01])

  return (
    <>
      {isSmallScreen ? <TableM token01={token01} resData={resData} /> : <Table token01={token01} resData={resData} />}
    </>
  )
}
